/*
 * mh-konf-track.js — Nutzung der vier Konfiguratoren in Google Analytics 4 (01.10.2026)
 *
 * Sendet Ereignisse an das vorhandene GA4 (gtag, G-1JEKYJVB9R) und zusaetzlich an Shopify
 * Customer Events (Shopify.analytics.publish). Keine eigenen Cookies, keine persoenlichen Daten.
 * GA4 zaehlt nur so, wie es die Cookie-Einwilligung des Besuchers erlaubt.
 *
 * Ereignisse (Parameter: konfigurator = WPC-Dielen | Terrassenplatten | Sichtschutzzaun |
 * Doppelstabmattenzaun, quelle = seite | popup):
 *   konfigurator_aufgerufen   Konfigurator ist sichtbar (Seite geladen oder PopUp geoeffnet)
 *   konfigurator_genutzt      erster Klick / erste Eingabe im Konfigurator
 *   konfigurator_warenkorb    Planung in den Warenkorb gelegt
 *   konfigurator_gespeichert  "Speichern & teilen" abgeschlossen
 *   konfigurator_pdf          "Planung exportieren" abgeschlossen
 *   konfigurator_ki_bild      fotorealistisches Bild / Zaun entfernen angefordert
 * Je Seitenaufruf wird "aufgerufen" und "genutzt" pro Konfigurator nur einmal gesendet.
 *
 * 05.10.2026 – Microsoft Clarity (Projekt xt061yrb91):
 *   Dieselben Ereignisse gehen zusaetzlich als Clarity-Events an Clarity, Schema
 *   konf_<key>_<schritt> mit key = wpc | terrassen | zaun | doppelstab:
 *     aufgerufen -> _view, genutzt -> _start, warenkorb -> _warenkorb,
 *     gespeichert -> _gespeichert, pdf -> _pdf, ki_bild -> _ki_bild
 *   Nur Clarity: erreichter Schritt im Konfigurator -> _schritt_1, _schritt_2, ...
 *   sowie _letzter_schritt (erst nach der ersten Interaktion).
 *   Clarity-Tags: konfigurator (key), konf_quelle (seite | popup), theme_rolle (main | unpublished).
 *   Clarity selbst laedt erst nach Statistik-Einwilligung (snippets/mh-clarity.liquid). Bis dahin
 *   sammelt die Clarity-Warteschlange nur lokal im Browser – ohne Einwilligung geht nichts raus.
 */
(function () {
  'use strict';
  if (window.__mhKonfTrack) return;
  window.__mhKonfTrack = true;

  var K = [
    { key: 'wpc',        name: 'WPC-Dielen',           sel: '#mhWpcRoot' },
    { key: 'terrassen',  name: 'Terrassenplatten',     sel: '#mhKonfRoot' },
    { key: 'zaun',       name: 'Sichtschutzzaun',      sel: '.mhzk-app' },
    { key: 'doppelstab', name: 'Doppelstabmattenzaun', sel: '.mhds-app' }
  ];
  var BY_NAME = {};
  K.forEach(function (k) { BY_NAME[k.name] = k; });

  function shown(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function quelle(el) { return el && el.closest && el.closest('.mhtk-modal,[role="dialog"]') ? 'popup' : 'seite'; }

  /* ---- Microsoft Clarity ---- */
  var CL = {
    konfigurator_aufgerufen: 'view',
    konfigurator_genutzt: 'start',
    konfigurator_warenkorb: 'warenkorb',
    konfigurator_gespeichert: 'gespeichert',
    konfigurator_pdf: 'pdf',
    konfigurator_ki_bild: 'ki_bild'
  };
  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  function clarity() { try { window.clarity.apply(window, arguments); } catch (e) {} }
  try { if (window.Shopify && Shopify.theme && Shopify.theme.role) clarity('set', 'theme_rolle', String(Shopify.theme.role)); } catch (e) {}
  function toClarity(ev, k, src) {
    var s = CL[ev];
    if (!s) return;
    if (ev === 'konfigurator_genutzt') {
      clarity('set', 'konfigurator', k.key);
      clarity('set', 'konf_quelle', src || 'seite');
      clarity('upgrade', 'konfigurator_' + k.key);
    }
    clarity('event', 'konf_' + k.key + '_' + s);
  }

  function send(ev, k, src) {
    var p = { konfigurator: k.name, quelle: src || 'seite' };
    toClarity(ev, k, src);
    try { if (typeof window.MH_TRACK_TEST === 'function') { window.MH_TRACK_TEST(ev, p); return; } } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', ev, p); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ev, p); } catch (e) {}
  }

  /* aufgerufen: sobald ein Konfigurator sichtbar wird */
  var seen = {}, used = {}, last = null, lastT = 0;
  function scan() {
    K.forEach(function (k) {
      var list = document.querySelectorAll(k.sel);
      for (var i = 0; i < list.length; i++) {
        if (!shown(list[i])) continue;
        var src = quelle(list[i]), id = k.key + ':' + src;
        if (!seen[id]) { seen[id] = 1; send('konfigurator_aufgerufen', k, src); }
        break;
      }
    });
  }

  /* Schritte (nur Clarity): hoechster erreichter Schritt je Konfigurator */
  var STEP = { wpc: '.stepper .step', terrassen: '.stepper .step', zaun: '.mhzk-step', doppelstab: '.mhds-step' };
  var maxStep = {}, lastStep = {};
  function steps(k, root) {
    var st = [];
    try { st = root.querySelectorAll(k.key === 'wpc' || k.key === 'terrassen' ? ':scope > .stepper .step' : STEP[k.key]); } catch (e) { st = []; }
    for (var n = root.parentElement, d = 0; !st.length && n && d < 4; n = n.parentElement, d++) {
      try { st = n.querySelectorAll(STEP[k.key]); } catch (e) { st = []; }
    }
    return st;
  }
  function scanSteps() {
    K.forEach(function (k) {
      var list = document.querySelectorAll(k.sel);
      for (var i = 0; i < list.length; i++) {
        if (!shown(list[i])) continue;
        var id = k.key + ':' + quelle(list[i]);
        if (!used[id]) break;
        var st = steps(k, list[i]), act = -1;
        for (var j = 0; j < st.length; j++) {
          if (st[j].classList.contains('active') || st[j].classList.contains('is-active')) act = j;
        }
        if (act < 0) break;
        var from = maxStep[id] == null ? 0 : maxStep[id] + 1;
        for (var s = from; s <= act; s++) clarity('event', 'konf_' + k.key + '_schritt_' + (s + 1));
        if (act >= from) maxStep[id] = act;
        if (act === st.length - 1 && !lastStep[id]) { lastStep[id] = 1; clarity('event', 'konf_' + k.key + '_letzter_schritt'); }
        break;
      }
    });
  }

  /* genutzt: erste Interaktion im Konfigurator */
  function hit(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    for (var i = 0; i < K.length; i++) {
      var r = t.closest(K[i].sel);
      if (!r) continue;
      last = K[i]; lastT = Date.now();
      var src = quelle(r), id = K[i].key + ':' + src;
      if (!used[id]) { used[id] = 1; send('konfigurator_genutzt', K[i], src); }
      setTimeout(scanSteps, 400);
      return;
    }
  }
  document.addEventListener('pointerdown', hit, true);
  document.addEventListener('keydown', hit, true);

  /* Warenkorb, Speichern, PDF, KI-Bild: an den Anfragen erkennen, die ohnehin rausgehen */
  var nf = window.fetch;
  if (nf) {
    window.fetch = function (input, init) {
      var ev = null, k = null;
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var body = init && typeof init.body === 'string' ? init.body : '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
          var m = /"_konfigurator"\s*:\s*"([^"]+)"/.exec(body);
          k = (m && BY_NAME[m[1]]) || (last && Date.now() - lastT < 60000 ? last : null);
          if (k) ev = 'konfigurator_warenkorb';
        } else if (/a\.klaviyo\.com\/client\/events/.test(url) && body) {
          var n = /"name"\s*:\s*"(Konfiguration gespeichert|Planung exportiert)"/.exec(body);
          var c = /"Konfigurator"\s*:\s*"([^"]+)"/.exec(body);
          if (n && c && BY_NAME[c[1]]) { k = BY_NAME[c[1]]; ev = n[1] === 'Planung exportiert' ? 'konfigurator_pdf' : 'konfigurator_gespeichert'; }
        } else if (/workers\.dev\/live(\?|$)/.test(url) && last) {
          k = last; ev = 'konfigurator_ki_bild';
        }
      } catch (e) { ev = null; }
      var p = nf.apply(this, arguments);
      if (ev && k) {
        var src = 'seite';
        try { var r = document.querySelector(k.sel); src = quelle(r); } catch (e) {}
        p.then(function (res) { if (res && res.ok) send(ev, k, src); }).catch(function () {});
      }
      return p;
    };
  }

  /* Wichtig: diese Datei muss VOR mh-konf-suite.js laden (snippets/mh-konf-aktion.liquid),
     damit die Suite ihre Klaviyo-Aufrufe ueber diesen fetch schickt. */
  scan();
  setInterval(function () { scan(); scanSteps(); }, 1500);
  document.addEventListener('visibilitychange', scan);
})();
